import type { FreightShipmentStatus } from './freight-details-types';

/**
 * Lookup from a normalized (lowercased) backend status string to a known
 * {@link FreightShipmentStatus}. Keys cover common spellings/casings the
 * backend may emit (e.g. `in_transit`, `in transit`, `intransit`).
 */
const STATUS_LOOKUP: Record<string, FreightShipmentStatus> = {
  booked: 'Booked',
  intransit: 'InTransit',
  'in transit': 'InTransit',
  in_transit: 'InTransit',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  canceled: 'Cancelled',
  exception: 'Exception',
};

/**
 * Narrows a raw backend status string to a known {@link FreightShipmentStatus}.
 *
 * Matching is case-insensitive and ignores surrounding whitespace. Unknown,
 * empty, null, or undefined inputs resolve to `null` so callers can render a
 * neutral/raw fallback. Pure — no side effects.
 */
export const parseFreightStatus = (raw: string | null | undefined): FreightShipmentStatus | null => {
  if (!raw) {
    return null;
  }

  const normalized = raw.trim().toLowerCase();

  return STATUS_LOOKUP[normalized] ?? null;
};
